import { useQuery } from '@tanstack/react-query';

import { gameSequenceKeys } from '@/hooks/tie-breaker/gameSequenceKeys';
import { getGameSequencesInfo } from '@/infrastructure/network/data/tiebreaker/tie-breaker';

export const useGameSequenceInfoQuery = (matchId: string, gameNumber: number) => {
	return useQuery({
		queryKey: gameSequenceKeys.gameSequenceInfo(matchId),
		queryFn: () => getGameSequencesInfo({ matchUuid: matchId, gameNumber }),
		enabled: !!matchId && !!gameNumber
	});
};
